import React from 'react';
import { Box, Typography, Button, Stepper, Step, StepLabel } from '@mui/material';
import { motion } from 'framer-motion'; // Import Framer Motion
import { Book, Assessment, TrendingUp } from '@mui/icons-material'; // Icons for steps

const FinancialIndependenceJourney = () => {
  const steps = [
    'Book a free session with us to discuss your financial needs & goals.',
    'We will assess your current financial fitness & suggest you customized solutions.',
    'Monitoring your financial growth & taking corrective actions.',
  ];

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', padding: 4 }}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Start Your Financial Independence Journey
        </Typography>
        <Typography variant="h6" align="center" paragraph>
          Take the first step towards achieving your financial freedom with our easy-to-follow process.
        </Typography>

        {/* Stepper for visual process */}
        <Stepper activeStep={0} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>
                <Typography variant="h6">{label}</Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Animated Steps with Icons */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 0.3 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Book sx={{ fontSize: 40, color: '#2980b9' }} />
              <Typography variant="h6">Step 1: Book a free session</Typography>
            </Box>
            <Typography variant="body1" color="text.secondary">
              Discuss your financial needs & goals with our expert team. Let’s get to know you better!
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 0.6 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Assessment sx={{ fontSize: 40, color: '#27ae60' }} />
              <Typography variant="h6">Step 2: Financial fitness assessment</Typography>
            </Box>
            <Typography variant="body1" color="text.secondary">
              We’ll evaluate your current financial situation and provide tailored solutions for you.
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 0.9 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TrendingUp sx={{ fontSize: 40, color: '#f39c12' }} />
              <Typography variant="h6">Step 3: Monitor & Grow</Typography>
            </Box>
            <Typography variant="body1" color="text.secondary">
              We’ll track your financial progress and provide continuous support to keep you on track.
            </Typography>
          </motion.div>

        </Box>

        {/* Call-to-action Button */}
        <Box sx={{ textAlign: 'center', marginTop: 4 }}>
          <Button variant="contained" color="primary" size="large" sx={{ fontSize: 18 }} href="#contact">
            Get Started Today
          </Button>
        </Box>
      </motion.div>
    </Box>
  );
};

export default FinancialIndependenceJourney;
